<template>
  <div class="formitem">
      <div class="title">{{field.text}}</div>
      <van-uploader v-model="imgvalue" multiple :max-size="20 * 1024 * 1024" @oversize="onOversize" :max-count="1" :afterRead="afterRead" :before-delete="beforeDelete"/>
  </div>
</template>

<script setup>
import { ref,defineProps, onMounted,toRefs } from "vue";
import API from "@/axios";
import {Toast} from "vant";
const props = defineProps({
  field: {
    type: Object,
    required: false,
  },
  defaultData: {
    type: Object,
    required: false
  },
  setData: {
    type: Function,
    required: false
  },
  name: {
    type: String,
    required: false
  }
});

const imgvalue = ref([]);

onMounted(()=>{
  if(defaultData.value){
    imgvalue.value = [{
      url: defaultData.value
    }];
  }
});
const onOversize = () => {
  Toast.fail('文件大小不能超过 20MB');
};
function afterRead(file){
  file.status = 'uploading';
  file.message = '上传中';
  let form = new FormData();
  form.append('file', file.file);
  API({
    url: '/web/uploadImg',
    method: "post",
    data:form,
    timeout: 60000,
  }).then((res) => {
    file.url = res.data.url;
    file.status = 'done';
    props.setData(name.value, file.url);
  });
}
function beforeDelete(){
  props.setData(name.value, '');
  return true;
}
const { field, name, defaultData } = toRefs(props);
</script>

<style lang="less" scoped>
.formitem {
  margin-top: 10px;
  margin-bottom: 30px;
}
.title{
  padding: 0px 20px 30px;
  font-size: @font-size;
  line-height: @font-size;
  color: @font-secondary-color;
  display: inline-block;
  vertical-align: top;
}
</style>
